// Main animation components
export {
  ScrollAnimation,
  FadeIn,
  FadeInUp,
  FadeInDown,
  SlideLeft,
  SlideRight,
  ScaleUp,
  RotateIn,
  FadeInUpSmall,
  FadeInUpLarge,
  FadeInDownLarge,
  SlideLeftLarge,
  SlideRightLarge,
  SlideUpNoOpacity,
  ClipHorizontal,
  HeightExpand,
  ClipCircleReveal,
} from "./ScrollAnimation";

// Stagger animations
export {
  StaggerAnimation,
  StaggerFadeInUp,
  StaggerFadeIn,
  StaggerScaleUp,
} from "./StaggerAnimation";

// Hooks
export { useInView } from "./useInView";

// Re-export types
export type { AnimationType } from "@/hooks/useScrollAnimation";
